import pptGenerationAgentInput from "../../assets/help-center/custom-agents/ppt-generation-agent-input.png";
import pptGenerationAgentOutput from "../../assets/help-center/custom-agents/ppt-generation-agent-output.png";
import excelGenerationAgentInput from "../../assets/help-center/custom-agents/excel-generation-agent-input.png";
import excelGenerationAgentOutput from "../../assets/help-center/custom-agents/excel-generation-agent-output.png";
import companyAnalysisAgentInput from "../../assets/help-center/custom-agents/company-analysis-agent-input.png";
import companyAnalysisAgentOutput from "../../assets/help-center/custom-agents/company-analysis-agent.png";
import dueDiligenceAgentInput from "../../assets/help-center/custom-agents/due-diligence-agent-input.png";
import dueDiligenceAgentOutput from "../../assets/help-center/custom-agents/due-diligence-agent-output.png";
import investmentAnalysisAgentInput from "../../assets/help-center/custom-agents/investment-analysis-agent-input.png";
import investmentAnalysisAgentOutput from "../../assets/help-center/custom-agents/investment-analysis-agent-output.png";
import businessMemoAgentInput from "../../assets/help-center/custom-agents/business-memo-agent-input.png";
import businessMemoAgentOutput from "../../assets/help-center/custom-agents/business-memo-agent-output.png";
import ceoQaPreparationAgentInput from "../../assets/help-center/custom-agents/ceo-qa-preparation-agent-input.png";
import ceoQaPreparationAgentOutput from "../../assets/help-center/custom-agents/ceo-qa-preparation-agent-output.png";
import speechGenerationAgentInput from "../../assets/help-center/custom-agents/speech-generation-agent-input.png";
import speechGenerationAgentOutput from "../../assets/help-center/custom-agents/speech-generation-agent-output.png";
import transcriptGenerationAgentInput from "../../assets/help-center/custom-agents/transcript-generation-agent-input.png";
import transcriptGenerationAgentOutput from "../../assets/help-center/custom-agents/transcript-generation-agent-output.png";
import handwrittenNotesImageAnalysisInput from "../../assets/help-center/custom-agents/handwritten-notes-image-analysis-input.png";
import handwrittenNotesImageAnalysisOutput from "../../assets/help-center/custom-agents/handwritten-notes-image-analysis-output.png";
import chatWorkspaceOverview from "../../assets/help-center/chat-workspace/chat-workspace-overview.png";
import chatWorkspaceElements from "../../assets/help-center/chat-workspace/chat-workspace-workspace-elements.png";
import chatWorkspaceNewChat from "../../assets/help-center/chat-workspace/chat-workspace-new-chat.png";
import chatWorkspaceAttachFiles from "../../assets/help-center/chat-workspace/chat-workspace-attach-files.png";
import chatWorkspaceResponseActions from "../../assets/help-center/chat-workspace/chat-workspace-response-actions.png";
import chatWorkspaceChatHistory from "../../assets/help-center/chat-workspace/chat-workspace-chat-history.png";
import chatWorkspaceRenameConversation from "../../assets/help-center/chat-workspace/chat-workspace-rename-conversation.png";
import loginAccountScreen from "../../assets/help-center/account-management/login-account-screen.png";
import resetPasswordInput from "../../assets/help-center/account-management/reset-password-input.png";
import resetPasswordCode from "../../assets/help-center/account-management/reset-password-code.png";
import privacyGlobalRepository from "../../assets/help-center/account-management/privacy-global-repository.png";
import privacyPersonalRepository from "../../assets/help-center/account-management/privacy-personal-repository.png";
import exportDownloadGeneratedFile from "../../assets/help-center/account-management/export-download-generated-file.png";
import exportYourData from "../../assets/help-center/account-management/export-your-data.png";
import trainFileActionButton from "../../assets/help-center/account-management/train-file-action-button.png";
import trainFilePermissions from "../../assets/help-center/account-management/train-file-permissions.png";
import chatHistoryShare from "../../assets/help-center/account-management/chat-history-share.png";

const updatedAt = "June 26, 2026";

const helpdesk = "[support@nextastra.com](mailto:support@nextastra.com)";
const velakodaSite = "[avalanchethinking.ai](https://avalanchethinking.ai/)";
const avalancheThinking = "[avalanchethinking.ai](https://avalanchethinking.ai)";

const article = (id, title, content) => ({
  id,
  title,
  updatedAt,
  content,
});

const helpImage = (src, alt) => `![${alt}](${src})`;

const chatWorkspaceOverviewSection = `## What is the Chat Workspace?

The Chat Workspace is the primary area where you interact with VelaKoda. It enables you to ask questions, generate business documents, upload files, interact with Custom Agents, and receive AI-powered responses.

## What's included in the Chat Workspace?

- Prompt input box
- AI model selector
- File attachment option
- Send button
- Chat actions
- Generated files
- Repository integration

## Example workspace
### Workspace elements

${helpImage(
  chatWorkspaceElements,
  "Chat workspace screenshot showing the prompt box, model selector, and quick actions"
)}`;

const chatWorkspaceStartChatSection = `## How do I start a new chat?

To begin a new conversation:

1. Click **New Chat** from the left navigation panel.
2. Select an AI model if required.
3. Enter your prompt in the message box.
4. Press **Enter** or click **Send**.

VelaKoda will generate a response based on your request.

## Tip

Start a new chat whenever you want to work on a completely different topic to keep conversations organized.

## Example workflow

### Input

${helpImage(
  chatWorkspaceNewChat,
  "New chat screenshot showing the chat workspace with the New Chat button and prompt area"
)}`
;

const chatWorkspaceAttachFilesSection = `## How do I attach files in chat?

VelaKoda supports multiple file formats, including:

- PDF
- Word
- Excel
- PowerPoint
- Images
- Text files

To upload a file:

1. Click the **Attachment** icon.
2. Browse and select the file.
3. Wait until the upload completes.
4. Enter your prompt.
5. Click **Send**.

## Examples

- Summarize this document.
- Generate a presentation from this file.
- Explain this image.
- Create a speech using this report.

## Example workflow

### Input

${helpImage(
  chatWorkspaceAttachFiles,
  "File attachment screenshot showing a file being uploaded in chat"
)}`
;

const chatWorkspaceResponseActionsSection = `## What actions can I perform on AI responses?

After VelaKoda generates a response, you can:

- Copy the response
- Download generated files
- View generated documents
- Train the document to Repository
- Continue asking follow-up questions
- Regenerate the response when available

## Example workflow

### Output

${helpImage(
  chatWorkspaceResponseActions,
  "AI response actions screenshot showing copy, download, view, train, and regenerate controls"
)}`;

const chatWorkspaceHistorySection = `## 3.5.1 What is Chat History?

Chat History stores all your previous conversations, allowing you to continue earlier discussions without losing context.

## Benefits

- Resume previous work
- Reuse prompts
- Access generated documents
- Track completed tasks
- Share conversations

## 3.5.2 How do I access previous chats?

1. Open the left navigation panel.
2. Click **Chat History**.
3. Select any conversation.
4. The complete conversation will open.

### Example workflow

#### Chat History

${helpImage(
  chatWorkspaceChatHistory,
  "Chat history screenshot showing the conversation list and shared conversation view"
)}

## 3.5.3 Can I rename a conversation?

To rename a chat:

1. Hover over the conversation.
2. Click the three-dot menu.
3. Select **Rename**.
4. Enter a meaningful title.
5. Click **Save**.

### Best Practice

Use descriptive names such as:

- Generate investment analysis report for Infosys
- What is the creator economy?
- Which startups got funded?

instead of New Chat.

### Rename conversation

${helpImage(
  chatWorkspaceRenameConversation,
  "Rename conversation screenshot showing the chat options menu and rename action"
)}`
;

const collection2LoginScreen = helpImage(
  loginAccountScreen,
  "Login screen showing the email and password fields"
);

const collection2ResetPasswordInput = helpImage(
  resetPasswordInput,
  "Forgot password screen showing the email input"
);

const collection2ResetPasswordCode = helpImage(
  resetPasswordCode,
  "Verification code screen showing the one-time code input"
);

const collection2PrivacyGlobalRepository = helpImage(
  privacyGlobalRepository,
  "Repository Organizer showing shared Global and Groups repositories"
);

const collection2PrivacyPersonalRepository = helpImage(
  privacyPersonalRepository,
  "Repository Organizer showing Personal Repository and Private workspace"
);

const collection2ExportDownloadGeneratedFile = helpImage(
  exportDownloadGeneratedFile,
  "Chat preview showing the Download button for a generated file"
);

const collection2ExportYourData = helpImage(
  exportYourData,
  "Repository Organizer showing exported content management"
);

const collection2TrainFileActionButton = helpImage(
  trainFileActionButton,
  "Repository Organizer showing the action menu used to send a file for training"
);

const collection2TrainFilePermissions = helpImage(
  trainFilePermissions,
  "Training permissions dialog showing destination repository choices"
);

const collection2ChatHistoryShare = helpImage(
  chatHistoryShare,
  "Chat history view showing the share button and conversation list"
);

const twoPagePptGenerationSection = `### Create a presentation

Generating a presentation is simple:

1. Type a prompt in the chat box, such as \`Generate 2-slide PPT for Google\`.
2. Press **Enter** or click the send icon.
3. VelaKoda creates the presentation and displays it in chat with **View**, **Download**, and **Train** options.
4. The generated \`.pptx\` file appears with a file name and size confirmation once complete.

### Example workflow

#### Input

${helpImage(
  pptGenerationAgentInput,
  "Two-slide PPT generation input screenshot showing a prompt for Google"
)}

#### Output

${helpImage(
  pptGenerationAgentOutput,
  "Two-slide PPT generation output screenshot showing the generated PowerPoint preview"
)}`;

const pptGenerationAgentSection = `### What does this agent do?

Creates professional PowerPoint presentations on any topic, company, industry, or trained document.

### Example prompts

- \`Generate a 5-slide PPT on Artificial Intelligence.\`
- \`Generate a company overview PPT for Apple.\`
- \`Generate a presentation on Digital Transformation.\``;

const pptSlideCountSection = `### Slide count

Yes. You can specify the number of slides directly in your prompt.

### Example prompts

- \`Generate PPT on Tesla of 5 slides\`
- \`Generate 10-slide presentation on renewable energy trends\`

### Best results

VelaKoda will attempt to match the requested slide count. For best results, specify a topic and a slide count together.`;

const pptDownloadSection = `### Download the file

Once your presentation is generated, it appears in chat as a file attachment.

1. Click **View** to open a preview of the slides.
2. In the preview window, click **Download** in the top-right corner.
3. Save the \`.pptx\` file to your device.`;

const pptTrainSection = `### Train the output

Yes. Every generated file includes a **Train** button alongside the **Download** and **View** options.

Clicking **Train** sends the file to your knowledge repository, making it available for future AI-powered searches, insights, and document generation tasks that draw on your trained content.`;

const pptPreviewSection = `### Preview slides

Click the **View** button that appears with the generated file in chat.

The presentation opens in a built-in viewer that lets you navigate between slides. You can then download it from within the viewer by clicking **Download**.`;

export const helpCategories = [
  {
    id: "get-started-with-velakoda",
    title: "Get Started with VelaKoda",
    displayTitle: "Collection 01",
    breadcrumbLabel: "Get Started",
    summary:
      "Learn what VelaKoda does, where to access it, which models it supports, and how to set up quick access.",
    articles: [
      article(
        "what-is-velakoda-and-what-can-i-use-it-for",
        "1.1 What is VelaKoda and what can I use it for?",
        `## What VelaKoda is

VelaKoda is an AI-powered assistant designed to help professionals and teams create business documents, presentations, reports, and speeches using simple natural language prompts.

## What you can use it for

- Generate PowerPoint presentations on any topic or company
- Create Excel sheets for financial analysis and market trend reports
- Produce due diligence, investment analysis, and company analysis reports
- Draft speeches and business memos
- Summarize and explain handwritten notes, images, and uploaded documents
- Generate transcripts and speeches from trained documents
- Ask questions about documents stored in your knowledge repository
`
      ),
      article(
        "what-ai-models-does-velakoda-support",
        "1.2 What AI models does VelaKoda support?",
        `## Model support

VelaKoda supports multiple AI models that you can switch between during a chat session. The model selector is visible at the top of the chat interface.

Currently supported models:

| Model | Usage |
| --- | --- |
| claude-sonnet | Best for detailed reasoning, structured writing, and polished long-form responses. |
| gpt-4o-mini | Best for faster responses, quick drafts, and lightweight everyday assistance. |
| gpt-4o | Best for broader general-purpose assistance with strong response quality. |
| deepseek | Best for reasoning-heavy tasks, coding help, and analytical workflows. |
| gemini-2.5-flash | Best for fast, lightweight responses and quick everyday use. |

## Why switch models

Switching models mid-conversation lets you compare outputs or choose the model best suited for a specific task - for example, using one model for analytical reports and another for creative speech writing.
`
      ),
      article(
        "quick-access-and-shortcuts",
        "1.3 Quick Access & Shortcuts",
        `Quick access makes VelaKoda easier to open from your desktop, browser, or mobile device without typing the website URL each time.

### 1.3.1 Quick access

Creating a shortcut gives you:

- One-click access to VelaKoda
- Faster document generation and research
- Easy access from your home screen or desktop
- Improved productivity for frequent users

### 1.3.2 Create a VelaKoda shortcut

#### Google Chrome (Windows/Mac)

1. Open VelaKoda in Chrome.
2. Click the three-dot menu in the top-right corner.
3. Select **Cast, Save and Share** and then **Install VelaKoda** or **Create Shortcut**.
4. Check **Open as Window** if you want.
5. Click **Install/Create**.

VelaKoda will now appear on your desktop and Start Menu for quick access.

#### Microsoft Edge

1. Open VelaKoda in Microsoft Edge.
2. Click the three-dot menu.
3. Select **Apps** and then **Install this site as an app**.
4. Click **Install**.

VelaKoda will launch like a desktop application.

### 1.3.3 Create a browser bookmark

#### Chrome, Edge, Firefox

1. Open VelaKoda.
2. Press <kbd>Ctrl</kbd> + <kbd>D</kbd> on Windows or <kbd>Cmd</kbd> + <kbd>D</kbd> on Mac.
3. Save the bookmark.
4. Add it to the Bookmarks Bar for one-click access.

### 1.3.4 Add VelaKoda to Android home screen

#### Android

1. Open VelaKoda in Chrome.
2. Tap the three-dot menu.
3. Select **Add to Home Screen**.
4. Enter the shortcut name (**VelaKoda**).
5. Tap **Add**.

A VelaKoda icon will be added to your mobile home screen.

### 1.3.5 Add VelaKoda to iPhone home screen

#### iPhone

1. Open VelaKoda in Safari.
2. Tap the **Share** button.
3. Scroll down and select **Add to Home Screen**.
4. Enter the name **VelaKoda**.
5. Tap **Add**.

The VelaKoda icon will appear on your iPhone home screen for instant access.
`
      ),
    ],
  },
  {
    id: "account-management",
    title: "Account Management",
    displayTitle: "Collection 02",
    breadcrumbLabel: "Account Management",
    summary:
      "Sign in, reset credentials, manage privacy, and export account data.",
    articles: [
      article(
        "how-do-i-log-in-to-my-velakoda-account",
        "2.1 How do I log in to my VelaKoda account?",
        `## Sign in

Go to ${avalancheThinking} and click **Log In**.

Enter your registered email address or username and password, then click **Sign In**.

If you forgot your password, click **Forgot Password** to receive a reset link by email.

${collection2LoginScreen}
`
      ),
      article(
        "how-do-i-change-the-email-address-on-my-account",
        "2.2 How do I change the email address on my account?",
        `## Update your email

To change your registered email address, contact ${helpdesk} with:

- Your current email address
- The new email address you want to use
`
      ),
      article(
        "how-do-i-reset-my-password",
        "2.3 How do I reset my password?",
        `## Reset steps

1. On the login page, click **Forgot Password**.
2. Enter your registered email address and submit the form.
3. VelaKoda sends a password reset link to that email.
4. Open the link, enter a new password, and confirm it to complete the reset.

${collection2ResetPasswordInput}

${collection2ResetPasswordCode}
`
      ),
      article(
        "who-can-view-my-conversations-and-uploaded-documents",
        "2.4 Who can view my conversations and uploaded documents?",
        `## Privacy First

VelaKoda is built on a **Privacy First** principle. Your personal conversations and documents stored in your **Personal Repository** are private to your account and are not visible to other users.

## Shared content

Documents uploaded to a **Global Repository** or shared **Groups** within your organization may be accessible to other authorized members of that organization.

Always review the repository settings before uploading sensitive documents.

${collection2PrivacyPersonalRepository}

${collection2PrivacyGlobalRepository}
`
      ),
      article(
        "how-do-i-contact-velakoda-support",
        "2.5 How do I contact VelaKoda support?",
        `## Contact support

You can reach the VelaKoda support team by emailing ${helpdesk}.

Include a description of your issue, any relevant screenshots, and your account email address so the team can assist you efficiently.

You can also visit ${velakodaSite} for self-service help resources.
`
      ),
      article(
        "how-do-i-export-my-data-from-velakoda",
        "2.6 How do I export my data from VelaKoda?",
        `## Export your data

VelaKoda allows you to export generated content, access previous conversations, and manage files from a centralized repository.

## Download generated files

Generated files such as PowerPoint presentations, Excel spreadsheets, Word reports, speeches, and other outputs can be downloaded directly from the chat interface by clicking the **Download** button available alongside each generated file.

${collection2ExportDownloadGeneratedFile}

## Manage files in My Drive

All generated files are automatically stored in the **My Drive** section within the Repository Organizer.

From **My Drive**, you can:

- View all generated files in one location
- Organize files into folders and categories
- Rename files for easier identification
- Delete files that are no longer required
- Train files into VelaKoda repositories (**Personal** / **Global**) for future AI-assisted search and retrieval

${collection2ExportYourData}

## Train files to VelaKoda

Files stored in **My Drive** can be added to your knowledge repositories, making them available for AI-powered search, analysis, and content generation.

Depending on your permissions, files can be trained to:

- **Global Repository**
- **Personal Repository**

Once trained, VelaKoda can use these documents to answer questions, generate reports, create presentations, and provide insights based on your organization's knowledge.

${collection2TrainFileActionButton}

${collection2TrainFilePermissions}

## Access and share chat history

Your previous conversations are available in the Chat History section, allowing you to revisit past discussions and generated outputs.

You can:

- View previous conversations
- Continue an existing chat
- Reference earlier responses and generated content
- Share conversations with colleagues for collaboration
- Export chat history for record-keeping and future reference

${collection2ChatHistoryShare}

## Related articles

- [What is the Repository Organizer in VelaKoda?](/help/repository-knowledge-base/what-is-the-repository-organizer-in-velakoda)
- [What are Trained Documents?](/help/repository-knowledge-base/what-are-trained-documents)
- [How do I train a document so VelaKoda can use it for answers?](/help/repository-knowledge-base/how-do-i-train-a-document-so-velakoda-can-use-it-for-answers)
- [What is the difference between Personal Repo, Global Repo, and Groups?](/help/repository-knowledge-base/what-is-the-difference-between-personal-repo-global-repo-and-groups)
- [How do I share content with my team?](/help/repository-knowledge-base/how-do-i-share-content-with-my-team)
`
      ),
    ],
  },
  {
    id: "chat-workspace",
    title: "Chat Workspace",
    displayTitle: "Collection 03",
    breadcrumbLabel: "Chat Workspace",
    summary:
      "Learn how to start chats, attach files, manage responses, and work with chat history in VelaKoda.",
    articles: [
      article(
        "what-is-the-chat-workspace",
        "3.1 What is the Chat Workspace?",
        chatWorkspaceOverviewSection
      ),
      article(
        "how-do-i-start-a-new-chat",
        "3.2 How do I start a new chat?",
        chatWorkspaceStartChatSection
      ),
      article(
        "how-do-i-attach-files-in-chat",
        "3.3 How do I attach files in chat?",
        chatWorkspaceAttachFilesSection
      ),
      article(
        "what-actions-can-i-perform-on-ai-responses",
        "3.4 What actions can I perform on AI responses?",
        chatWorkspaceResponseActionsSection
      ),
      article(
        "chat-history",
        "3.5 Chat History",
        chatWorkspaceHistorySection
      ),
    ],
  },
  {
    id: "custom-agents",
    title: "Custom Agents",
    displayTitle: "Collection 04",
    breadcrumbLabel: "Custom Agents",
    summary:
      "Explore task-specific AI agents for presentations, spreadsheets, reports, speeches, transcripts, handwritten notes, and executive prep.",
    articles: [
      article(
        "what-are-custom-agents",
        "4.1 What are Custom Agents?",
        `## What Custom Agents are

Custom Agents are specialized AI assistants designed to perform specific business tasks. Each agent is pre-configured with instructions, workflows, and expertise to generate high-quality outputs with minimal prompting.

## Benefits of Custom Agents

- Faster content generation
- Consistent output quality
- Reduced prompt-writing effort
- Task-specific expertise
- Business-ready deliverables
`
      ),
      article(
        "available-custom-agents",
        "4.2 Available Custom Agents",
        `## Available agents

| Agent | Purpose |
| --- | --- |
| PPT Generation Agent | Create PowerPoint presentations |
| Excel Generation Agent | Generate spreadsheets and analysis |
| Company Analysis Agent | Analyze companies and generate reports |
| Due Diligence Agent | Generate due diligence reports |
| Investment Analysis Agent | Create investment research reports |
| Business Memo Agent | Generate business memos |
| CEO Q&A Preparation Agent | Create executive meeting preparation guides |
| Speech Generation Agent | Create speeches and presentations |
| Transcript Generation Agent | Generate transcripts from PPTs and documents |
| Handwritten Notes & Image Analysis | Summarize handwritten notes and explain images |
`
      ),
      article(
        "ppt-generation-agent",
        "4.4 PPT Generation Agent",
        `## 4.4.1 2-Slide PPT Generation

${twoPagePptGenerationSection}

## 4.4.2 Multi-Slide PPT Generation Agent

${pptGenerationAgentSection}

## 4.4.3 Control slide count

${pptSlideCountSection}

## 4.4.4 Download a presentation

${pptDownloadSection}

## 4.4.5 Train a generated PPT

${pptTrainSection}

## 4.4.6 View a presentation

${pptPreviewSection}
`
      ),
      article(
        "excel-generation-agent",
        "4.5 Excel Generation Agent",
        `## What does this agent do?

Generates Excel spreadsheets for financial analysis, benchmarking, forecasting, and market research.

## Example prompts

- \`Generate financial performance sheet for Microsoft.\`
- \`Generate market trends analysis spreadsheet.\`
- \`Generate competitor comparison Excel report.\`

## Example workflow

### Input

${helpImage(
  excelGenerationAgentInput,
  "Excel generation input screenshot showing a spreadsheet request"
)}

### Output

${helpImage(
  excelGenerationAgentOutput,
  "Excel generation output screenshot showing the generated workbook"
)}
`
      ),
      article(
        "company-analysis-agent",
        "4.6 Company Analysis Agent",
        `## What does this agent do?

Creates comprehensive company analysis reports including business overview, financial performance, competitive positioning, and strategic insights.

## Example prompts

- \`Generate company analysis report for Infosys.\`
- \`Analyze Tata Consultancy Services.\`
- \`Generate company overview for Reliance Industries.\`

## Example workflow

### Input

${helpImage(
  companyAnalysisAgentInput,
  "Company analysis input screenshot showing a company report request"
)}

### Output

${helpImage(
  companyAnalysisAgentOutput,
  "Company analysis output screenshot showing the generated company report"
)}
`
      ),
      article(
        "due-diligence-agent",
        "4.7 Due Diligence Agent",
        `## What does this agent do?

Creates detailed due diligence reports for investment, acquisition, partnership, and vendor evaluation purposes.

## Example prompts

- \`Generate due diligence report on Amazon.\`
- \`Generate due diligence report on Tesla.\`
- \`Create acquisition assessment for Company XYZ.\`

## Example workflow

### Input

${helpImage(
  dueDiligenceAgentInput,
  "Due diligence input screenshot showing a report request"
)}

### Output

${helpImage(
  dueDiligenceAgentOutput,
  "Due diligence output screenshot showing the generated report preview"
)}
`
      ),
      article(
        "investment-analysis-agent",
        "4.8 Investment Analysis Agent",
        `## What does this agent do?

Generates investment-focused reports including market position, financial performance, risks, opportunities, and growth outlook.

## Example prompts

- \`Generate investment analysis report for Infosys.\`
- \`Analyze investment potential of Nvidia.\`
- \`Generate equity research report on Microsoft.\`

## Example workflow

### Input

${helpImage(
  investmentAnalysisAgentInput,
  "Investment analysis input screenshot showing a report request"
)}

### Output

${helpImage(
  investmentAnalysisAgentOutput,
  "Investment analysis output screenshot showing the generated report preview"
)}
`
      ),
      article(
        "business-memo-agent",
        "4.9 Business Memo Agent",
        `## What does this agent do?

Creates structured business memorandums suitable for executive communication and decision-making.

## Example prompts

- \`Generate business memo on Reliance Industries.\`
- \`Create executive memo on market expansion strategy.\`

## Example workflow

### Input

${helpImage(
  businessMemoAgentInput,
  "Business memo input screenshot showing a memo request"
)}

### Output

${helpImage(
  businessMemoAgentOutput,
  "Business memo output screenshot showing the generated memo preview"
)}
`
      ),
      article(
        "ceo-qa-preparation-agent",
        "4.10 CEO Q&A Preparation Agent",
        `## What does this agent do?

Generates executive briefing documents and suggested questions before leadership meetings.

## Example prompts

- \`Generate Q&A prep for CEO visit to Microsoft.\`
- \`Create executive meeting preparation guide for Apple.\`

## Example workflow

### Input

${helpImage(
  ceoQaPreparationAgentInput,
  "CEO Q&A preparation input screenshot showing a meeting prep request"
)}

### Output

${helpImage(
  ceoQaPreparationAgentOutput,
  "CEO Q&A preparation output screenshot showing the generated guide preview"
)}
`
      ),
      article(
        "speech-generation-agent",
        "4.11 Speech Generation Agent",
        `## What does this agent do?

Creates speeches, keynote addresses, presentations, and speaking notes.

## Example prompts

- \`Generate speech on Women's Day.\`
- \`Generate keynote speech on Artificial Intelligence.\`
- \`Generate speech using attached file.\`

## Example workflow

### Input

${helpImage(
  speechGenerationAgentInput,
  "Speech generation input screenshot showing a speech request"
)}

### Output

${helpImage(
  speechGenerationAgentOutput,
  "Speech generation output screenshot showing the generated speech PDF"
)}
`
      ),
      article(
        "transcript-generation-agent",
        "4.12 Transcript Generation Agent",
        `## What does this agent do?

Converts presentations and documents into presentation transcripts and speaker notes.

## Example prompts

- \`Generate transcript for attached PPT.\`
- \`Create speaker notes from attached presentation.\`
- When the user attaches a PPT and wants narration in chuck tone, use \`Generate Persona script for each slide\`.

## Example workflow

### Input

${helpImage(
  transcriptGenerationAgentInput,
  "Transcript generation input screenshot showing a document-to-script request"
)}

### Output

${helpImage(
  transcriptGenerationAgentOutput,
  "Transcript generation output screenshot showing the generated transcript preview"
)}
`
      ),
      article(
        "custom-agent-handwritten-notes-image-analysis",
        "4.13 Handwritten Notes & Image Analysis",
        `## What does this agent do?

Summarizes handwritten notes, explains diagrams and images, and works with uploaded files.

## Example prompts

- \`Can VelaKoda read and summarize handwritten notes or images?\`
- \`How do I summarize an attached file or image?\`
- \`How do I ask VelaKoda to explain the content of an uploaded file?\`

## Example workflow

### Input

${helpImage(
  handwrittenNotesImageAnalysisInput,
  "Handwritten notes input screenshot showing an uploaded note summary request"
)}

### Output

${helpImage(
  handwrittenNotesImageAnalysisOutput,
  "Handwritten notes output screenshot showing the summarized response"
)}
`
      ),
    ],
  },
  {
    id: "ppt-generation",
    title: "PPT Generation",
    displayTitle: "Collection 05",
    breadcrumbLabel: "PPT Generation",
    summary:
      "Create presentations from prompts, control slide count, preview outputs, and train generated decks.",
    articles: [
      article(
        "how-do-i-generate-a-powerpoint-presentation-in-velakoda",
        "5.1 How do I generate a PowerPoint presentation in VelaKoda?",
        `${twoPagePptGenerationSection}`
      ),
      article(
        "can-i-control-the-number-of-slides-in-a-generated-ppt",
        "5.2 Can I control the number of slides in a generated PPT?",
        `${pptSlideCountSection}`
      ),
      article(
        "how-do-i-download-a-generated-presentation",
        "5.3 How do I download a generated presentation?",
        `${pptDownloadSection}`
      ),
      article(
        "can-i-send-a-generated-ppt-to-my-knowledge-repository-for-training",
        "5.4 Can I send a generated PPT to my knowledge repository for training?",
        `${pptTrainSection}`
      ),
      article(
        "how-do-i-view-a-generated-presentation-inside-velakoda",
        "5.5 How do I view a generated presentation inside VelaKoda?",
        `${pptPreviewSection}`
      ),
    ],
  },
  {
    id: "excel-sheet-generation",
    title: "Excel Sheet Generation",
    displayTitle: "Collection 06",
    breadcrumbLabel: "Excel Sheets",
    summary:
      "Generate spreadsheets for financial analysis, market trends, comparisons, and forecasting.",
    articles: [
      article(
        "how-do-i-generate-an-excel-sheet-in-velakoda",
        "6.1 How do I generate an Excel sheet in VelaKoda?",
        `## Generate a spreadsheet

Type a prompt describing the spreadsheet you need. For example:

- \`Generate Excel Sheet for check financial performance of Apple\`
- \`Generate Excel Sheet on market trends analysis\`

Press **Enter**. VelaKoda creates the \`.xlsx\` file and displays it in chat with **View**, **Download**, and **Train** options.
`
      ),
      article(
        "what-types-of-excel-reports-can-velakoda-generate",
        "6.2 What types of Excel reports can VelaKoda generate?",
        `## Report types

VelaKoda can generate a wide range of Excel reports, including:

- Financial performance sheets such as income statements, balance sheets, and cash flow statements
- Market trends analysis by segment and growth rate
- Competitor comparison tables
- Sales and revenue forecasting models
- Industry benchmarking spreadsheets

Simply describe the type of analysis you need in your prompt and VelaKoda will structure the data accordingly.
`
      ),
      article(
        "can-i-generate-financial-performance-sheets-for-a-specific-company",
        "6.3 Can I generate financial performance sheets for a specific company?",
        `## Company-specific sheets

Yes. Use a prompt like \`Generate Excel Sheet for check financial performance of Microsoft\`.

VelaKoda will draw on available data to produce a structured spreadsheet with multiple tabs, typically including:

- Income Statement
- Balance Sheet
- Cash Flow Statement
`
      ),
      article(
        "how-do-i-download-and-open-a-generated-excel-file",
        "6.4 How do I download and open a generated Excel file?",
        `## Preview and open

Click the **View** button on the generated file in chat to preview the spreadsheet inside VelaKoda.

Click **Download** to save the \`.xlsx\` file to your device. The file can then be opened in Microsoft Excel, Google Sheets, or any compatible spreadsheet application.
`
      ),
    ],
  },
  {
    id: "report-generation",
    title: "Report Generation",
    displayTitle: "Collection 07",
    breadcrumbLabel: "Reports",
    summary:
      "Build business reports, due diligence packs, investment analysis, company overviews, Q&A guides, and memos.",
    articles: [
      article(
        "what-types-of-reports-can-velakoda-generate",
        "7.1 What types of reports can VelaKoda generate?",
        `## Report formats

VelaKoda can generate professional-grade business reports including:

- Due diligence reports
- Investment analysis reports
- Company analysis reports
- Q&A preparation guides for executive meetings
- Business memos

Reports are generated as downloadable Word (\`.docx\`) or PDF files with structured sections, executive summaries, and key findings.
`
      ),
      article(
        "how-do-i-generate-a-due-diligence-report",
        "7.2 How do I generate a due diligence report?",
        `## Generate the report

Enter a prompt such as \`Generate due diligence report on Amazon\` and press **Enter**.

VelaKoda performs a deep research process and generates a structured Outside-In Due Diligence Report in PDF or Word format, including:

- Company snapshot
- Investment and acquisition assessment
- Financial overview
- Confidential classification header

The report is available to **View**, **Download**, or **Train** once complete.
`
      ),
      article(
        "how-do-i-generate-an-investment-analysis-report",
        "7.3 How do I generate an investment analysis report?",
        `## Investment analysis

Use a prompt like \`Generate investment analysis report for Infosys\`.

VelaKoda produces a comprehensive report covering:

- Financial performance
- Strategic investments
- Market positioning
- Growth outlook

The output is delivered as a downloadable Word or PDF document.
`
      ),
      article(
        "how-do-i-generate-a-company-analysis-report",
        "7.4 How do I generate a company analysis report?",
        `## Company analysis

Type \`Generate company analysis report for Tata Consultancy Services\` and press **Enter**.

VelaKoda generates a structured company report including:

- An executive summary
- A company overview table
- Key financial metrics
- Business highlights
`
      ),
      article(
        "how-do-i-prepare-a-q-and-a-guide-for-a-ceo-meeting-using-velakoda",
        "7.5 How do I prepare a Q&A guide for a CEO meeting using VelaKoda?",
        `## Q&A preparation guide

Use the prompt \`Generate qa prep to visit ceo of [Company name]\`.

VelaKoda creates a Q&A Preparation Guide that includes:

- Company context
- Suggested discussion topics
- Key financial talking points
- Meeting approach tips
- Strategic questions to raise during the visit
`
      ),
      article(
        "how-do-i-generate-a-business-memo",
        "7.6 How do I generate a business memo?",
        `## Business memo

Enter a prompt such as \`Generate business memo of Reliance Industries\`.

VelaKoda produces a formal memorandum in Word format with sections including:

- Summary
- Background
- Key findings
- Recommendations

The memo is formatted and ready to share with stakeholders.
`
      ),
    ],
  },
  {
    id: "speech-generation",
    title: "Speech Generation",
    displayTitle: "Collection 08",
    breadcrumbLabel: "Speech Generation",
    summary:
      "Generate speeches from prompts or trained documents and download them as ready-to-use PDFs.",
    articles: [
      article(
        "how-do-i-generate-a-speech-on-any-topic",
        "8.1 How do I generate a speech on any topic?",
        `## Create a speech

Type a prompt like \`Generate Speech on Women's Day\` or \`Generate Speech on Digital Transformation\` and press **Enter**.

VelaKoda creates a structured, engaging speech in PDF format, complete with:

- An introduction
- Key arguments
- Supporting points
- A strong conclusion

The speech is available to **View**, **Download**, or **Train** once generated.
`
      ),
      article(
        "can-i-generate-a-speech-based-on-a-trained-document",
        "8.2 Can I generate a speech based on a trained document?",
        `## Use an attached file

Yes. Attach a document to your chat and enter the prompt \`Generate speech using attached file\`.

VelaKoda analyzes the document and creates a speech that draws directly on the content, data, and insights within it - ideal for presentations grounded in your own research or reports.
`
      ),
      article(
        "how-do-i-download-a-generated-speech",
        "8.3 How do I download a generated speech?",
        `## Download the PDF

Once the speech is generated, it appears as a PDF file in chat.

1. Click **View** to open it in the built-in viewer.
2. Click **Download** to save it to your device.
3. Print it or use it as a speaker's script.
`
      ),
    ],
  },
  {
    id: "handwritten-notes-image-analysis",
    title: "Handwritten Notes & Image Analysis",
    displayTitle: "Collection 09",
    breadcrumbLabel: "Notes & Images",
    summary:
      "Summarize handwritten notes, explain diagrams and images, and work with uploaded files.",
    articles: [
      article(
        "can-velakoda-read-and-summarize-handwritten-notes-or-images",
        "9.1 Can VelaKoda read and summarize handwritten notes or images?",
        `## Supported inputs

Yes. VelaKoda can process uploaded images including handwritten notes, diagrams, screenshots, and photographs. It uses AI vision capabilities to extract and interpret the content.

## How to use it

Simply attach the image file to your chat message and include a prompt such as:

- \`Summarize this attached file\`
- \`Explain this image\`
`
      ),
      article(
        "how-do-i-summarize-an-attached-file-or-image",
        "9.2 How do I summarize an attached file or image?",
        `## Summarize an upload

1. Click the attachment icon in the chat input area.
2. Select your image, PDF, or document file.
3. Type \`Summarize this attached file\`.
4. Press **Enter**.

VelaKoda returns a structured summary with a title, key sections, and bullet points covering the main content. A **Knowledge Base Source** link also appears, allowing you to view the original file or start a new chat from it.
`
      ),
      article(
        "how-do-i-ask-velakoda-to-explain-the-content-of-an-uploaded-file",
        "9.3 How do I ask VelaKoda to explain the content of an uploaded file?",
        `## Explain the file

Attach your file and enter the prompt \`Explain attached file\`.

VelaKoda provides a detailed explanation of the content including:

- An image overview
- Key components identified
- A rating or assessment where applicable

This is useful for understanding complex diagrams, system architecture screenshots, or technical notes.
`
      ),
    ],
  },
  {
    id: "repository-knowledge-base",
    title: "Repository & Knowledge Base",
    displayTitle: "Collection 10",
    breadcrumbLabel: "Repository",
    summary:
      "Organize trained files, understand repository scopes, and use trained content for answers and reports.",
    articles: [
      article(
        "what-is-the-repository-organizer-in-velakoda",
        "10.1 What is the Repository Organizer in VelaKoda?",
        `## Repository Organizer

The Repository Organizer is a document management interface within VelaKoda where you can store, organize, and manage files that have been trained for AI-powered search and insights. It is accessible from the left-hand navigation panel.

## What you can do there

From the Repository Organizer, you can:

- Upload new files
- View existing trained documents
- Check their status as **Approved** or **Active**
- Select files to use as context for new AI tasks
`
      ),
      article(
        "what-is-the-difference-between-personal-repo-global-repo-and-groups",
        "10.2 What is the difference between Personal Repo, Global Repo, and Groups?",
        `## Repository scopes

VelaKoda organizes your knowledge base into three scopes:

- **Personal Repo** - Your private collection of documents trained and available for personal AI-assisted search and insights. Only you can access these.
- **Global Repo** - Organization-wide knowledge base containing approved documents made searchable by all authorized members of your organization.
- **Groups** - Team-specific repositories where shared documents are trained for AI-powered discovery and retrieval by members of a particular group or department.
`
      ),
      article(
        "how-do-i-train-a-document-so-velakoda-can-use-it-for-answers",
        "10.3 How do I train a document so VelaKoda can use it for answers?",
        `## Two ways to train

There are two ways to train a document:

1. After generating a file such as a PPT, Excel sheet, or report, click the **Train** button that appears alongside the output in chat. This sends it directly to your repository.
2. In the Repository Organizer, upload a file and mark it for training. Once processed, its status changes to **Approved / Active**, meaning VelaKoda can now draw on it when answering queries or generating documents.
`
      ),
      article(
        "how-do-i-generate-a-due-diligence-report-from-trained-or-selected-documents",
        "10.4 How do I generate a due diligence report from trained or selected documents?",
        `## Use your documents as source material

To generate a report grounded in your own trained documents:

1. Open the Repository Organizer.
2. Select one or more files by ticking their checkboxes.
3. Click **New Chat** or **Ask a Query**.
4. In chat, enter \`Generate due diligence report for [Company name]\`.
5. Press **Enter**.

VelaKoda generates the report using the selected documents as its primary source, ensuring the output is grounded in your organization's specific data.
`
      ),
      article(
        "how-do-i-explore-insights-from-trained-documents",
        "10.5 How do I explore insights from trained documents?",
        `## Ask questions from your repository

Attach a trained document in chat and enter the prompt \`Explore Insights from Trained Documents\`, or ask a specific question such as \`What was the global energy industry revenue in 2024?\`

VelaKoda returns a structured answer with:

- Key data points
- Source context
- Related Questions you can explore further

A **Knowledge Base Source** link identifies which trained document the insight came from.
`
      ),
      article(
        "what-is-the-private-section-in-the-repository-used-for",
        "10.6 What is the Private section in the repository used for?",
        `## Private section

The Private section is a staging area where generated content is stored before you decide to train it and add it to a shared or personal repository.

It allows you to review, organize, and manage AI-generated files such as reports and presentations before making them available for AI-assisted search and retrieval across your account.
`
      ),
      article(
        "what-are-trained-documents",
        "10.7 What are Trained Documents?",
        `## Trained documents

Trained documents are files that VelaKoda has processed and made available for AI-powered search, analysis, and generation.

Once a document is trained, VelaKoda can use it to:

- Answer questions based on your content
- Generate reports, presentations, and summaries
- Provide insights grounded in your organization's knowledge
`
      ),
      article(
        "how-do-i-share-content-with-my-team",
        "10.8 How do I share content with my team?",
        `## Share content

To share content with your team, move or train the relevant file into a shared repository such as **Global** or the appropriate **Group** repository.

You can then allow authorized team members to access, search, and use that content for collaborative work.

## Best practice

- Use **Personal Repository** for private drafts and personal reference material
- Use **Group Repository** for department or project collaboration
- Use **Global Repository** for organization-wide shared knowledge
`
      ),
    ],
  },
  {
    id: "transcripts-and-presentations-from-trained-documents",
    title: "Transcripts & Presentations from Trained Documents",
    displayTitle: "Collection 11",
    breadcrumbLabel: "Trained Documents",
    summary:
      "Turn trained documents into transcripts, presentations, and speeches with source-aware outputs.",
    articles: [
      article(
        "how-do-i-generate-a-transcript-for-an-attached-ppt",
        "11.1 How do I generate a transcript for an attached PPT?",
        `## Generate a transcript

Attach your PowerPoint file to the chat and enter the prompt \`Generate Transcript for attached File\`. Press **Enter**.

VelaKoda analyzes each slide and produces a spoken-word transcript structured with time-coded sections such as:

- 0:00 - Introduction
- 0:15 - Revenue by Segment

The output is displayed in chat and can be downloaded. A **Knowledge Base Source** link also appears so you can reference the original PPT.
`
      ),
      article(
        "how-do-i-generate-a-presentation-from-trained-documents",
        "11.2 How do I generate a presentation from trained documents?",
        `## Generate slides from source material

Attach a trained document and enter:

- \`Generate Presentations from Trained Documents\`
- \`generate only ppt on attached file\`

VelaKoda creates a PowerPoint presentation based on the document's content, structure, and key data points.

The generated \`.pptx\` file is available to **View**, **Download**, or **Train** once complete.
`
      ),
      article(
        "how-do-i-generate-a-speech-from-a-trained-document",
        "11.3 How do I generate a speech from a trained document?",
        `## Generate a speech

Attach a document and type \`Generate speech using attached file\`.

VelaKoda crafts a structured speech that draws on the content, data, and insights from your document, including:

- An introduction
- Main body sections with data references
- A closing

This is ideal for preparing conference presentations, investor briefings, or keynote addresses grounded in your own research.
`
      ),
    ],
  },
  {
    id: "response-customization-settings",
    title: "Response Customization Settings",
    displayTitle: "Collection 12",
    breadcrumbLabel: "Response Settings",
    summary:
      "Adjust tone, length, AI role, and your role to personalize how VelaKoda responds.",
    articles: [
      article(
        "how-do-i-customize-how-velakoda-responds-to-me",
        "12.1 How do I customize how VelaKoda responds to me?",
        `## Open the panel

Click the **Customize Responses** icon found at the bottom-left of the chat interface, near the version number. A panel appears with four settings:

- Tone & Style
- Length of Responses
- AI Role
- Your Role

## Apply changes

Adjust each setting to your preference and click **Apply**.

Click **Cancel** to discard changes, or the reset icon to restore all defaults.
`
      ),
      article(
        "what-tone-and-style-options-are-available-in-velakoda",
        "12.2 What Tone & Style options are available in VelaKoda?",
        `## Tone & Style options

VelaKoda offers the following Tone & Style options:

- **Neutral (Default)** - Balanced, clear communication
- **Simple** - Beginner-friendly, easy-to-understand language
- **Summary** - Concise, condensed responses
- **Professional** - Polished, formal tone suitable for business communication
- **Naturally** - Conversational and approachable
- **Deep** - Thorough, in-depth analysis and detail
`
      ),
      article(
        "how-do-i-set-the-ai-role-in-velakoda",
        "12.3 How do I set the AI Role in VelaKoda?",
        `## AI Role

The AI Role setting defines the persona and expertise VelaKoda adopts when responding.

Available roles include:

- General Assistant (Default)
- Brainstorm Partner
- Career Coach
- Coding Coach
- Editor
- Marketer
- Product Manager
- Summarizer
- Teacher
- Writer
- And more

Select the role that best matches your task. For example, choose **Marketer** when crafting branding copy, or **Summarizer** when condensing long reports.
`
      ),
      article(
        "how-do-i-set-my-own-role-to-get-more-relevant-responses",
        "12.4 How do I set my own role to get more relevant responses?",
        `## Your Role

Under **Your Role** in the Customize Responses panel, select the option that describes you:

- **Universal (Default)** - General-purpose responses
- **Parent** - Supportive, family-friendly tone
- **Professional** - Formal and business-ready
- **Programmer** - Technical language with code examples
- **Student** - Learning-focused explanations
- **Writer** - Focus on wording, flow, and clarity

Setting your role helps VelaKoda tailor the depth, vocabulary, and format of its responses to suit your background.
`
      ),
      article(
        "how-do-i-change-the-length-of-velakodas-responses",
        "12.5 How do I change the length of VelaKoda's responses?",
        `## Response length

In the Customize Responses panel, adjust the **Length of Responses** setting.

Options typically range from shortest, which gives brief summaries, to longest, which provides detailed, comprehensive answers.

Select **Longest (Default)** for full reports and analyses, or a shorter setting for quick answers during exploratory chats.
`
      ),
    ],
  },
];
